import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { GABRIELA_SUBTITLE, CHANIRA_SUBTITLE } from '../config';
import { QUEENS_PHOTO } from '../data/photos';
import { PhotoPlaceholder } from './PhotoPlaceholder';
import { Reveal } from './Reveal';

// One shared photo of both Queens: Gabriela on the left (blonde), Chanira on the
// right (dark curly hair). No individual portrait slots.
const PROFILES = [{
  name: 'GABRIELA',
  // Optional. Renders nothing while empty — never generate a placeholder credential.
  subtitle: GABRIELA_SUBTITLE,
  bio: 'queens.gabriela.bio'
}, {
  name: 'CHANIRA',
  subtitle: CHANIRA_SUBTITLE,
  bio: 'queens.chanira.bio'
}];
export function MeetTheQueens() {
  const {
    t
  } = useLanguage();
  return <section id="queens" className="w-full bg-white" data-id="element-173" data-mp="37fvau5wo0a2e">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-24" data-id="element-174" data-mp="37h58wv3ipi91">
        <Reveal className="max-w-2xl" data-id="element-175" data-mp="3ce58qo9rxorp">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-176" data-mp="3cf6r7dt4ddjg">
            {t('queens.eyebrow')}
          </p>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-177" data-mp="3unpomv4yqfut" />
          <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl" data-id="element-178" data-mp="3qmdwoiym9ijg">
            {t('queens.title')}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-body sm:text-lg" data-id="element-179" data-mp="3ll6q2n87mped">
            {t('queens.support')}
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:gap-14" data-id="element-180" data-mp="i6az5617xa8u">
          <Reveal data-id="element-181" data-mp="d66k7kfyknkq">
            <figure data-id="element-182" data-mp="d5n1i1ihhv5n">
              <div className="aspect-square w-full overflow-hidden bg-offwhite" data-id="element-183" data-mp="88dd8p6tzpje">
                {QUEENS_PHOTO ? <img src={QUEENS_PHOTO} alt={t('queens.alt.both')} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-184" data-mp="2xy89lpk3bhgg" /> : <PhotoPlaceholder label={t('queens.photo.wide')} tone="warm" data-id="element-185" data-mp="2zevt6a50b3s9" />}
              </div>
              <figcaption className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] text-camelink" data-id="element-186" data-mp="2lfmdrcomkdpc">
                {t('queens.caption')}
              </figcaption>
            </figure>
          </Reveal>

          <div className="space-y-10" data-id="element-187" data-mp="2bp1h3usihj92">
            {PROFILES.map((profile, index) => <Reveal key={profile.name} delay={index * 0.1} data-id="element-188" data-mp="2ggjmqw5hc80d" data-mpi={index}>
                <article data-id="element-189" data-mp="2ghunso7jj1ns">
                  <h3 className="font-display text-2xl font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-190" data-mp="22ov6cgo76xdl">
                    {profile.name}
                  </h3>
                  {profile.subtitle ? <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-camelink" data-id="element-191" data-mp="1spw1782n5jvc">
                      {profile.subtitle}
                    </p> : null}
                  <div aria-hidden="true" className="mt-4 h-px w-14 bg-camel" data-id="element-192" data-mp="1e371p68e36oy" />
                  <p className="mt-4 text-base leading-relaxed text-body" data-id="element-193" data-mp="194nfd4pvvsw2">{t(profile.bio)}</p>
                </article>
              </Reveal>)}
          </div>
        </div>

        <Reveal className="mt-14" delay={0.1} data-id="element-194" data-mp="1nzjt1xggp8gj">
          <blockquote className="mx-auto max-w-3xl text-center font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-195" data-mp="1j1s1x5nn5qde">
            {t('queens.quote')}
            <footer className="mt-4 text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-196" data-mp="1s3hvoi4zx1ec">
              Gabriela + Chanira
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>;
}